export function getThreadOpponentId(threadUserIds: string[], authUserId: string) {
  return threadUserIds.find(id => id !== authUserId) ?? null;
}
